import type { IAppState } from 'shared/common/state';
import { selectIsUserAgent } from 'shared/packages/Filters/shared/selectors';
import type { ISpecialPromoBuilderOffersSchema } from 'shared/repositories/commercial-search-offers/entities/special_promo_builder_offers/SpecialPromoBuilderOffersSchema';

import { resultsSelector } from '../commonSelectors';

/** Возвращает undefined, если пользователь агент. Иначе возвращает specialPromoBuilderOffers. Для агентов не должно быть блока 3СП */
export const selectSpecialPromoBuilderOffers = (state: IAppState): ISpecialPromoBuilderOffersSchema | undefined =>
  selectIsUserAgent(state) ? undefined : resultsSelector(state).specialPromoBuilderOffers;
